export const transformOcupacoes = ({ data }) =>
  data.map(dado => {
    return {
      ...dado,
      id: dado.pkImovelTipoOcupacao,
      value: dado.pkImovelTipoOcupacao,
      label: dado.nome
    };
  });
